<script>
export default {
  name: 'WishlistModal',
  props: {
    product: {
      type: Object,
      default: {}
    }
  },
  created () {
  },
  methods: {
    closeModal () {
      this.$emit('onClose')
    }
  }
}
</script>
<template>
    <!-- MODAL AREA START (Wishlist Modal) -->
    <div>
    <div class="ltn__modal-area ltn__add-to-cart-modal-area">
        <div class="modal fade show" id="liton_wishlist_modal" tabindex="-1" style="display:block; ">
            <div class="modal-dialog modal-md" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" @click="closeModal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                         <div class="ltn__quick-view-modal-inner">
                             <div class="modal-product-item">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="modal-product-img">
                                            <img src="/static/img/product/7.png" alt="#">
                                        </div>
                                         <div class="modal-product-info">
                                            <h5><a href="product-details.html">{{ product.product_name }}</a></h5>
                                            <p class="added-cart"><i class="fa fa-check-circle"></i>  Successfully added to your Wishlist</p>
                                            <div class="btn-wrapper">
                                                <router-link to="/account" class="theme-btn-1 btn btn-effect-1">View Wishlist</router-link>
                                            </div>
                                         </div>
                                         <!-- additional-info -->
                                         <div class="additional-info d-none">
                                            <p>We want to give you <b>10% discount</b> for your first order, <br>  Use discount code at checkout</p>
                                            <div class="payment-method">
                                                <img src="/static/img/icons/payment.png" alt="#">
                                            </div>
                                         </div>
                                    </div>
                                </div>
                             </div>
                         </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show"></div>
    </div>
    <!-- MODAL AREA END -->
</template>



// WEBPACK FOOTER //
// src/components/shared/WishlistModal.vue